<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :max-width="1000"
  >
    <template slot="header">
      <span>{{ item.id ? `Update Record #${item.id}` : 'Create New Record' }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          class="pb-0"
          cols="2"
        >
          <inventory-class-select-element
            v-model="item.inventory_class_id"
            :is-required="true"
            :is-add-all="false"
            :is-inst="false"
            :is-glass="false"
            :is-vwd-glass="false"
            :is-panels="false"
            :disabled="isDisabled || item.id != 0"
            :is-parts="false"
            :is-sid="false"
            :is-rail-part="false"
            :is-railings="false"
            @on-change="onInventoryClassChange"
          />
        </v-col>
        <v-col cols="5">
          <v-autocomplete
            v-model="item.location_id"
            :items="locations"
            item-text="name"
            item-value="id"
            label="Location"
            clearable
            :rules="[(v) => !!v || 'Location is required']"
          >
            <template slot="label">
              Location<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <!-- <v-col cols="5">
          <v-autocomplete
            v-model="item.ship_to_location_id"
            :items="locations"
            item-text="name"
            item-value="id"
            label="Ship To Location"
            clearable
          >
            <template slot="label">
              Ship To Location
            </template>
          </v-autocomplete>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col
          class="pt-0"
        >
          <v-autocomplete
            v-model="item.job_id"
            :items="jobs"
            :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
            item-value="id"
            :no-data-text="!item.inventory_class_id ? 'Select an Inventory Class first' : 'No data available'"
            :rules="[(v) => !!v || 'Project/Job is required']"
            :disabled="isDisabled || item.id != 0"
            clearable
            :loading="loadingJob"
          >
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                v-if="item && (item.sub_class_color || item.sub_class_name)"
                small
                :color="item.sub_class_color"
                text-color="white"
                class="mr-2"
              >
                {{ item.sub_class_name }}
              </v-chip>
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #item="{ item }">
              <v-chip
                v-if="item && (item.sub_class_color || item.sub_class_name)"
                small
                :color="item.sub_class_color"
                text-color="white"
                class="mr-2"
              >
                {{ item.sub_class_name }}
              </v-chip>
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <template slot="label">
              Project/Job<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="auto"
          class="text-end pb-0 pt-6 pl-0 pr-0"
        >
          <v-btn
            v-if="!item.id"
            color="primary"
            outlined
            small
            @click="openJobForm()"
          >
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
          <!-- <v-btn
            v-else
            color="primary"
            outlined
            small
            @click="openUpdateJobForm()"
          >
            <v-row>
              <v-col
                cols="auto"
                class="pr-0 pl-2"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-col>
              <v-col
                cols="auto"
                class="pl-1"
              >
                <span style="font-size: 15px;">
                  EDIT</span>
              </v-col>
            </v-row>
          </v-btn> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
        >
          <v-text-field
            v-model="item.wip_panel_quantity"
            type="number"
            disabled
          >
            <template slot="label">
              WIP Panel Quantity
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="3"
        >
          <v-menu
            ref="menuCompletionDate"
            v-model="dateMenuCompletionDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="item.production_completion_date"
                readonly
                append-icon="mdi-calendar"
                v-bind="attrs"
                :rules="[(v) => !!v || 'Production Completion Date is required']"
                :disabled="isDisabled"
                v-on="on"
              >
                <template slot="label">
                  Production Date<RedAsterisk />
                </template>
              </v-text-field>
            </template>
            <business-date-picker
              v-model="item.production_completion_date"
              no-title
              scrollable
              :min="getMinDateProd()"
              @input="onProductionCompletionDateChange"
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="item.production_completion_date = null"
              >
                Clear
              </v-btn>
            </business-date-picker>
          </v-menu>
        </v-col>
        <!-- <v-col
          cols="3"
        >
          <v-menu
            ref="menuShipDate"
            v-model="dateMenuShipDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="item.planned_ship_date"
                readonly
                append-icon="mdi-calendar"
                v-bind="attrs"
                :rules="[(v) => !!v || 'Ship Date is required']"
                :disabled="isDisabled"
                v-on="on"
              >
                <template slot="label">
                  Ship Date<RedAsterisk />
                </template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="item.planned_ship_date"
              no-title
              scrollable
              :min="weekdayAfterTomorrow"
              @input="onPlannedShipDateChange"
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="item.planned_ship_date = null"
              >
                Clear
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col> -->
      </v-row>
      <v-row v-if="!item.id">
        <v-col class="pb-0">
          <span>Note</span>
        </v-col>
      </v-row>
      <v-row v-if="!item.id">
        <v-col class="pt-0">
          <v-textarea
            v-model="item.note_text"
            outlined
            rows="3"
          />
        </v-col>
      </v-row>
      <job-form
        v-show="false"
        ref="jobForm"
        :is-supervisor="false"
        :is-client="false"
        :is-sub-class="true"
        :is-show-pending="true"
        :is-job-name="false"
        :is-address="false"
        @success="jobSuccess()"
      />
      <production-schedule-job-update-form
        v-show="false"
        ref="updateJobForm"
        @success="get(item.id)"
      />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import { addWeekdaysMoment, subtractWeekdaysMoment } from '@/helpers/DateHelpers';
import JobForm from '@/components/forms/jobs/JobForm';
import ProductionScheduleJobUpdateForm from '@/components/forms/productionSchedules/ProductionScheduleJobUpdateForm';
import BusinessDatePicker from '@/components/elements/BusinessDatePicker.vue';

export default {
  components: {
    BusinessDatePicker,
    JobForm,
    ProductionScheduleJobUpdateForm,
  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      inventory_class_id: 2,
      job_id: null,
      wo_number: null,
      wip_panel_quantity: 0,
      planned_ship_date: null,
      production_completion_date: null,
      production_completion_time: '07:00',
      note_text: null,
      location_id: null,
      sub_class_id: null,
      // planned_ship_time: '00:00',
      // ship_to_location_id: null,
      location_id: null,
    },

    jobs: [],
    noteStatuses: [],
    poNumbers: [],
    roles: [],
    locations: [],

    noteStatusIdShort: 2,
    dateMenuRequiredBy: false,
    dateMenuShipDate: false,
    dateMenuCompletionDate: false,
    isDisabled: true,
    isDisabledVertical: false,
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdProdAdmin: 22,
    userRoleIdPanelAdmin: 38,
    isUpdate: false,
    windowsSum: 0,

    classId4500: 1,
    classId4800: 2,
    subClassIdCornerPost: 2,
    subClassIdEuroDoor: 3,
    isManual: 0,
    loadingJob: false,
    statusIdInProgress: 1,
    statusIdCompleted: 2,
    statusIdOnHand: 3,

    locationId300Chrislea: 8,
    locationId14Precidio: 3,

    today: new Date().toISOString().substr(0, 10),
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters([

    ]),
    weekdayAfterToday() {
      const today = moment().format("YYYY-MM-DD");
      return addWeekdaysMoment(today, 1);
    },
    weekdayAfterTomorrow() {
      const today = moment().format("YYYY-MM-DD");
      return addWeekdaysMoment(today, 2);
    },
    dayAfterFive() {
      const today = moment().format("YYYY-MM-DD");
      return addWeekdaysMoment(today, 5);
    },
    dayAfterSix() {
      const today = moment().format("YYYY-MM-DD");
      return addWeekdaysMoment(today, 6);
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    // 'item.inventory_class_id': function (value) {
    //   if (value == null) return;
    //   if (this.item != null && this.item.job_id != null) {
    //     this.getJobs(null, this.item.job_id);
    //   }
    //   this.getLocations();
    // },
    // eslint-disable-next-line func-names
    'item.job_id': function (value) {
      this.isDisabledVertical = false;
      if (value == null) return;

      const job = this.jobs.find((x) => x.id === value);
      if (job == null) return;

      if (job.sub_class_id) {
        this.item.sub_class_id = job.sub_class_id;

        if (job.sub_class_id === this.subClassIdEuroDoor) {
          const locationId14Precidio = 3;
          this.item.location_id = locationId14Precidio;
        } else if (job.sub_class_id === this.subClassIdCornerPost) {
          const locationId14Precidio = 3;
          this.item.location_id = locationId14Precidio;
        }
      }

      if (this.isUpdate) return;

      this.item.wo_number = job.code;
    },
  },
  created() {
    this.item = { ...this.itemDto };
    this.roles = this.user.roles.map((x) => x.id);
    this.isDisabled = !(this.roles.includes(this.userRoleIdAdmin) || this.roles.includes(this.userRoleIdApprover) || this.roles.includes(this.userRoleIdProdAdmin) || this.roles.includes(this.userRoleIdPanelAdmin));
  },
  methods: {
    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.wipPanelSchedule.read(submitModel);
      if (!res || !res.data || res.data.length === 0) return;
      const firstIndex = 0;
      this.item = res.data[firstIndex];
      this.getJobs(null, this.item ? this.item.job_id : null);
      this.$nextTick(() => {
        this.isUpdate = false;
      });

    },

    async getJobs(jobCode = null, jobId = null) {
      this.loadingJob = true;
      const submitModel = {
        filters: {
          inventory_class_id: this.item.inventory_class_id, is_sub_class: 1,
          id: jobId,
        },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.jobs = res;

      if (jobCode) {
        const job = this.jobs.find((x) => x.code === jobCode);
        if (job) {
          this.item.job_id = job.id;
        }
      }
      this.loadingJob = false;
    },

    async getLocations() {
      // const locationId460Hanlan = 10;
      // const locationId99Vinyl = 3;
      // const locationId141Adesso = 8;
      // const locationId300Chrislea = 2;
      const locations = await this.$api.location.getList();
      this.locations = locations.filter((x) => x.id === this.locationId300Chrislea || x.id === this.locationId14Precidio);
      // if (this.item.inventory_class_id === this.classId4800) { this.locations = locations.filter((x) => x.id === locationId99Vinyl || x.id === locationId141Adesso || x.id === locationId300Chrislea); } else if (this.item.inventory_class_id === this.classId4500) { this.locations = locations.filter((x) => x.id === locationId141Adesso); } else { this.locations = locations; }
    },

    async submit() {
      if (!this.item) return false;
      let res;
      if (this.item.id) {
        res = await this.$api.wipPanelSchedule.update(this.item);
      } else {
        res = await this.$api.wipPanelSchedule.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }
      if (res !== true) {
        this.$bus.$emit('showError', res);
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.isUpdate = true;
        this.item.id = id;
        this.isManual = 1;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };

        this.isManual = 0;
        this.getJobs();
      }
      this.$refs.dialogBox.open();
      this.getLocations();
      if (!id) {
        this.item.production_completion_time = '07:00';
        // this.item.planned_ship_time = '00:00';
      }
    },

    async openJobForm() {
      const res = await this.$api.job.get('generate-manual-code');
      if (!res) return;
      this.$refs.jobForm.open();
      this.$nextTick(() => {
        this.$refs.jobForm.item.code = res;
        this.$refs.jobForm.item.is_manual = 1;
        if (this.item.inventory_class_id) this.$refs.jobForm.item.inventory_class_id = this.item.inventory_class_id;
      });
    },

    openUpdateJobForm() {
      this.$refs.updateJobForm.open(this.item);
    },

    async jobSuccess() {
      this.isManual = 1;
      await this.getJobs();
      const latestItemId = Math.max(...this.jobs.map((x) => x.id));
      if (latestItemId) { this.item.job_id = latestItemId; }
    },

    onProductionCompletionDateChange() {
      this.$refs.menuCompletionDate.save(this.item.production_completion_date);

      if (this.item.status_id === this.statusIdCompleted || this.item.status_id === this.statusIdInProgress) return;

      const date = addWeekdaysMoment(this.item.production_completion_date, 1);
      
      this.item.planned_ship_date = date;
    },

    onPlannedShipDateChange() {
      this.$refs.menuShipDate.save(this.item.planned_ship_date);

      if (this.item.status_id === this.statusIdCompleted || this.item.status_id === this.statusIdInProgress) return;

      const date = subtractWeekdaysMoment(this.item.planned_ship_date, 1);

      this.item.production_completion_date = date;
    },

    onInventoryClassChange(inventoryClassId) {
      if (inventoryClassId == null) return;
      this.item.inventory_class_id = inventoryClassId;
      this.getJobs();
    },

    getSum() {
      return parseInt(this.item.window_verticals === null ? 0 : this.item.window_verticals, 10) + parseInt(this.item.euro_doors === null ? 0 : this.item.euro_doors, 10);
    },

    isJobManual() {
      const job = this.jobs.find((x) => x.id === this.item.job_id);
      if (!job) return false;
      return job.is_manual;
    },

    // getMinDate() {
    //   if (!this.item.job) return this.dayAfterSix;
    //   const subclassIdCornerPost = 2;
    //   if (this.item.job.sub_class_id === subclassIdCornerPost || this.item.job.reference.includes('BS')) {
    //     return this.today;
    //   }
    //   return this.dayAfterSix;
    // },

    getMinDateProd() {
      if (!this.item.job) return this.weekdayAfterToday;
      const subclassIdCornerPost = 2;
      if (this.item.job.sub_class_id === subclassIdCornerPost || this.item.job.reference.includes('BS')) {
        return this.today;
      }
      return this.weekdayAfterToday;
    },

    subtractWeekdays(date, days) {
      const result = new Date(date);
      let remaining = days;

      while (remaining > 0) {
        result.setDate(result.getDate() - 1);
        const day = result.getDay();
        if (day !== 5 && day !== 6) {
          // eslint-disable-next-line no-plusplus
          remaining--;
        }
      }

      return result;
    },
  },
};
</script>
